import { render, staticRenderFns } from "./SuperPrivacyIntroductionPage.vue?vue&type=template&id=5e732636&scoped=true"
import script from "./SuperPrivacyIntroductionPage.vue?vue&type=script&lang=js"
export * from "./SuperPrivacyIntroductionPage.vue?vue&type=script&lang=js"
import style0 from "./SuperPrivacyIntroductionPage.vue?vue&type=style&index=0&id=5e732636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e732636",
  null
  
)

export default component.exports